module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gallery', {
    attrs: {
      "selector": ("gallery-" + (_vm.node.nid)),
      "articleTitle": _vm.node.title,
      "theme": _vm.theme
    }
  }, _vm._l((_vm.slideshow), function(val, key) {
    return _c('div', {
      key: key,
      staticClass: "thumbnail",
      class: {
        first: key === 0
      },
      attrs: {
        "slot": "thumbnail",
        "enLarge": val.style_1320w,
        "thumbnail": val.style_600x600,
        "progressive": val.style_134w,
        "data-w": val.width,
        "data-h": val.height,
        "data-caption": val.title,
        "data-title": val.title
      },
      slot: "thumbnail"
    }, [_c('div', {
      staticClass: "photos"
    }, [_c('progressive-image', {
      attrs: {
        "mode": "background",
        "progressiveImage": _vm.progressiveImages[key],
        "alt": _vm.node.title
      }
    })], 1), (key === 0 || key === 1) ? _c('div', {
      staticClass: "gallery-icon",
      class: {
        'number-one': key === 0, 'number-two': key === 1
      }
    }, [_c('svg-icon-gallery', {
      attrs: {
        "width": "10%",
        "height": "10%"
      }
    })], 1) : _vm._e(), (_vm.slideshow.length > 4 && key === 3) ? _c('div', {
      staticClass: "overlay"
    }, [_c('span', [_vm._v("+" + _vm._s((_vm.slideshow.length - key - 1)))])]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64caa5e2","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/ArticleGallery.vue
// module id = 1761
// module chunks = 1